import { gql } from '@apollo/client'

const INGREDIENT_KEYWORD_NODE_FRAGMENT = gql`
  fragment IngredientKeywordNode on IngredientKeywordNode {
    id
    parentId
    level
    idPath
    namePath
    term
    ingredientId
    suggestedType
    type
    subtype
    source
    languageId
    isName
    misspellingsCount
    translationsCount
    lemmatizationsCount
  }
`

export default INGREDIENT_KEYWORD_NODE_FRAGMENT
